import { Logo } from '@/components/logo';

const links = [
  {
    title: 'Privacy Policy',
    href: '/privacy-policy',
  },
  {
    title: 'Terms of Use',
    href: '/terms-of-use',
  },
  {
    title: 'Contact Us',
    href: '/contact-us',
  },
  {
    title: 'About',
    href: '/about',
  },
];

export default function FooterSection() {
  return (
    <footer className="py-16">
      <div className="mx-auto max-w-5xl px-6">
        <a href="/" className="mx-auto block size-fit">
          <Logo />
        </a>

        <div className="my-8 flex flex-wrap justify-center gap-6 text-sm">
          {links.map((link, index) => (
            <a
              key={index}
              href={link.href}
              className="text-muted-foreground hover:text-primary block duration-150"
            >
              <span>{link.title}</span>
            </a>
          ))}
        </div>
        <span className="text-muted-foreground block text-center text-sm">
          © {new Date().getFullYear()} Yashna Labs LLC. Boundr and related marks. All rights
          reserved.
        </span>
      </div>
    </footer>
  );
}
